<template>
  <div class="custom-scrollbar">
    <ul v-if="functionType == 0">
      <li v-for="item in roleList">
        <div class="roleBox" :class="{'roleBoxAct':checkActOrNot(item)}">
          <img :src="getSrc(item)" alt="" /><span>{{item.rolename}}</span>
        </div>
      </li>
    </ul>
    <ul v-else>
      <li v-for="item in roleList">
        <div class="roleBox" :class="{'roleBoxAct':checkActOrNot(item)}" @click="checkItem(item)">
          <img :src="getSrc(item)" alt="" /><span>{{item.rolename}}</span>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
  import resourcesStore from '@/cache/resourcesStore.js'
  import userManagerStore from '@/page/userManager/userManagerStore.js'
  export default {
    components: {

    },
    props: {
      nowCheckedIds: {
        type: Array,
        default() {
          return []
        }
      },
      // 0只是展示，1可进行编辑
      functionType: {
        type: Number,
        default() {
          return 1
        }
      },
    },
    data() {
      return {

      }
    },
    computed: {
      getSrc(item) {
        return item => {
          return resourcesStore.getters.getResourcesByName('/roleList/' + (this.nowCheckedIds.includes(item.id) ? 'checked.png' : 'unchecked.png'))
        }
      },
      roleList() {
        var a = [
          {
            "createTime": 1687760718000,
            "roleid": "0131001935b3478788877ca016f78047",
            "rolename": "储能管理系统",
            "memo": "储能管理系统",
            "id": "0131001935b3478788877ca016f78047",
            "entityName": "PcmRole"
          },
          {
            "createTime": null,
            "roleid": "2bed17d38ae74ba895aac1b9b1b50879",
            "rolename": "智慧能源",
            "memo": "能源管理相关功能",
            "id": "2bed17d38ae74ba895aac1b9b1b50879",
            "entityName": "PcmRole"
          },
          {
            "createTime": null,
            "roleid": "511e5c2dbed04631b8dd94665935a2f7",
            "rolename": "光伏",
            "memo": "",
            "id": "511e5c2dbed04631b8dd94665935a2f7",
            "entityName": "PcmRole"
          },
          {
            "createTime": 1689322184000,
            "roleid": "651106925e434652afac3853b977f082",
            "rolename": "公共机构能碳监测管理端系统",
            "memo": "",
            "id": "651106925e434652afac3853b977f082",
            "entityName": "PcmRole"
          },
          {
            "createTime": 1706164652000,
            "roleid": "655b5bb637964aeb8ee779e74c89a66d",
            "rolename": "1",
            "memo": "",
            "id": "655b5bb637964aeb8ee779e74c89a66d",
            "entityName": "PcmRole"
          },
          {
            "createTime": null,
            "roleid": "77f86b4b6ac946c983fa22cbd5c07f82",
            "rolename": "系统角色",
            "memo": "系统自带角色",
            "id": "77f86b4b6ac946c983fa22cbd5c07f82",
            "entityName": "PcmRole"
          },
          {
            "createTime": null,
            "roleid": "95339c27066046d682f61b1d9403b84c",
            "rolename": "用电服务",
            "memo": "用电服务",
            "id": "95339c27066046d682f61b1d9403b84c",
            "entityName": "PcmRole"
          },
          {
            "createTime": 1687772888000,
            "roleid": "b7ca913f6b1446c7a887f7f7e0294bea",
            "rolename": "光伏运营系统",
            "memo": "",
            "id": "b7ca913f6b1446c7a887f7f7e0294bea",
            "entityName": "PcmRole"
          },
          {
            "createTime": 1698283699000,
            "roleid": "c3a1d6423c3b4571a3ee584a1c348685",
            "rolename": "配电房",
            "memo": "配电房",
            "id": "c3a1d6423c3b4571a3ee584a1c348685",
            "entityName": "PcmRole"
          },
          {
            "createTime": 1697439590000,
            "roleid": "cf756a5e445340d08a10fc4c7c403a96",
            "rolename": "抄表管理",
            "memo": "抄表管理系统",
            "id": "cf756a5e445340d08a10fc4c7c403a96",
            "entityName": "PcmRole"
          },
          {
            "createTime": 1706150507000,
            "roleid": "d366a46fb73f4e048a2234403a2dd19c",
            "rolename": "2",
            "memo": "2",
            "id": "d366a46fb73f4e048a2234403a2dd19c",
            "entityName": "PcmRole"
          },
          {
            "createTime": 1706155078000,
            "roleid": "e8cf7a8417fa4600843c3dc916880abb",
            "rolename": "2",
            "memo": "2",
            "id": "e8cf7a8417fa4600843c3dc916880abb",
            "entityName": "PcmRole"
          },
          {
            "createTime": null,
            "roleid": "f4555396c5284ee0865f73a2e8600c1e",
            "rolename": getName(),
            "memo": "温度监控管理(科技蓝)",
            "id": "f4555396c5284ee0865f73a2e8600c1e",
            "entityName": "PcmRole"
          }
        ];
        return a
      }
    },
    watch: {

    },
    mounted() {
      if (isempty(this.nowCheckedIds) && this.functionType != 0) {
        for (let i = 0; i < this.roleList.length; i++) {
          if (this.roleList[i].rolename == "系统角色") {
            this.nowCheckedIds.push(this.roleList[i].id)
          }
        }
      }
    },
    methods: {
      checkItem(item) {
        if (this.nowCheckedIds.includes(item.id)) {
          this.$delete(this.nowCheckedIds, this.nowCheckedIds.indexOf(item.id))
        } else {
          this.$set(this.nowCheckedIds, this.nowCheckedIds.length, item.id)
        }
      },
      checkActOrNot(item) {
        return this.nowCheckedIds.includes(item.id)
      },
    }
  }
</script>

<style>
  li {
    margin-bottom: 12px;
  }

  .roleBox {
    display: inline-flex;
    border: solid 1px #E4E4E4;
    width: 120px;
    height: 32px;
    border-radius: 2px;
    align-items: center;
  }

  .roleBox>img {
    margin: 0 6px 0 12px;
  }

  .roleBox>span {
    font-size: .12rem;
  }

  .roleBoxAct {
    border-color: #3D7EFF;
  }

  .roleBoxAct span {
    color: #3D7EFF;
  }
</style>